import Handlebars from 'handlebars';
import EventHub from '~/eventHub';
import timeline_template from '~/templates/tra-timeline.handlebars';
import GeneralView from '~/generalView';
import toastr from 'toastr';

var traTimelineView = GeneralView.View.extend({
    tagName: "div",
    className: '',
    trazobj: '',
    kind: '',
    trazreport: '',
    changeorderbtntext: 'Ver Orden Descendente',
    events: {
        'click #timelinechangeorder':'orderarray',
    },

    render: function () {
        this.attachEvents();
        return this;
    },

    orderarray: function(){
        this.trazobj.models = [].concat(this.trazobj.models).reverse();
        var handlebarsTemplate = Handlebars.template(timeline_template);
        this.$el.html(handlebarsTemplate(this.trazobj));
		$('.timelineloader').hide();
        this.settittle(this.kind,this.trazreport);
        if (this.changeorderbtntext == "Ver Orden Descendente") {
            this.changeorderbtntext = "Ver Orden Ascendente"; 
            $("#timelinechangeorder").text(this.changeorderbtntext);
        }else{
            this.changeorderbtntext = "Ver Orden Descendente"; 
            $("#timelinechangeorder").text(this.changeorderbtntext);
        }
    },
        

    settittle: function(kind,trazreport){
		if (kind == 'report') {
            $(".timelinetittle").text("Línea de Tiempo para reporte: "+ trazreport.report[0].id);
            $(".linktotable").attr("href", "#tables?kind=report&id="+trazreport.report[0].id);
        }
        if (kind == 'user') {
            $(".timelinetittle").text("Línea de Tiempo para usuario: "+ trazreport.user[0].attributes.username);
            $(".linktotable").attr("href", "#tables?kind=user&id="+trazreport.user[0].id+'&username='+trazreport.user[0].attributes.username); 
        }
    },

    showtimeline: function(trazreport,kind){
		var arrayobj = this.settraz(trazreport,kind);
        this.trazobj = arrayobj;
        this.kind = kind; 
        this.trazreport = trazreport;
        var handlebarsTemplate = Handlebars.template(timeline_template);
        for (let index = 0; index < arrayobj.models.length; index++) {
            if(arrayobj.models[index].title == 'Comentario' && arrayobj.models[index].user == 'Auditor' ){
                arrayobj.models[index].user = "Usuario Anónimo";
            }             
        }
        this.$el.html(handlebarsTemplate(arrayobj));
		$('.timelineloader').hide();
        this.settittle(kind, trazreport);
        $("#timelinechangeorder").text(this.changeorderbtntext);
        this.translate();
    },

    attachEvents: function() { 
		this.listenTo(EventHub, 'report:timeline', data => {
			var handlebarsTemplate = Handlebars.template(timeline_template);
			this.$el.html(handlebarsTemplate(this.trazobj));
			this.$el.find('#timelinecontainer').hide();
            if (data.kind == 'report') {
				var obj = {
					report: [{
						id: data.ID
					}]
				};
				this.settittle(data.kind, obj);
                Parse.Cloud.run("gettrazreport",{"reportID": data.ID}).then((trazreport) => {
                    this.showtimeline(trazreport,data.kind);
                },
				(error) => {
					console.log(error);
					switch(error.code){
						case 100:
							toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
						break;
					}
				});
            }
            if (data.kind == 'user') {
                var obj = {
					user: [{
						id: data.ID,
						attributes: {
							username: data.username
						}
					}]
				};
				this.settittle(data.kind, obj);
				Parse.Cloud.run("gettrazuser",{"userID": data.ID}).then((trazuser) => {
                    this.showtimeline(trazuser,data.kind);
                },
				(error) => {
					console.log(error);
					switch(error.code){
						case 100:
							toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
						break;
					}
				}); 
            }
        });
            
    },
});
export default traTimelineView;
